module.exports = __webpack_public_path__ + "images/graphic-arrows_6b3bcb33baa2f2168b4f8fdb3b847d45.png";